<template>
	<div class="map_box2">
		<div class="duo_box" @click = "getduoiD13">
			<div class="duo_img13"></div>
			<div class="duo_text">15-4-13</div>
		</div>
		<div class="duo_box" @click = "getduoiD15">
			<div class="duo_img15"></div>
			<div class="duo_text">15-4-15</div>
		</div>
		<div class="black_w2d" @click="hidew2d">返回</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				siteId: '',
				siteType: '',
			}
		},
		methods: {
			hidew2d: function() {
				this.$emit('back')
			},
			getduoiD13: function() {
				let body={
					siteId: '271',
					siteType: '05',
					siteName: '15-4-13垛',
				}
				this.$emit('getduoiD13',body)
			},
			getduoiD15: function() {
				let body={
					siteId: '272',
					siteType: '05',
					siteName: '15-4-15垛',
				}
				this.$emit('getduoiD15',body)
			}
		},
	}
</script>

<style>
	.map_box2 {
		width: 52.9375rem;
		height: 36.25rem;
		/* background-color: red; */
		/* 		background-image: url('../../../assets/map/组 2012394.png'); */
		z-index: 999;
		position: absolute;
		left: 23.4375rem;
		top: 0;
		padding-left: 0.3125rem;
		padding-right: 0.3125rem;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding-left: 9.125rem;
		padding-right: 9.125rem;
	}
	.duo_box{
		width: 10.9375rem;
		height: 14.375rem;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.duo_img13{
		width: 10.9375rem;
		height: 11.25rem;
		background-image: url(../../../assets/map/duo13.png);
	}
	.duo_img15{
		width: 10.9375rem;
		height: 11.25rem;
		background-image: url(../../../assets/map/duo15.png);
	}
	.duo_text{
		width: 10.9375rem;
		height: 1.125rem;
		line-height: 1.125rem;
		color: #FFFFFF;
		text-align: center;
	}
	.black_w2d{
		position: absolute;
		top: 0;
		left: 24.25rem;
		width: 3.125rem;
		height: 1.5625rem;
		background-color: #0074D9;
		color: #FFFFFF;
	}
</style>



// WEBPACK FOOTER //
// src/page/maintain/main/w2dDuo.vue